import { CrmMarketResponse } from '../generated';

export const testCrmMarketResponse: CrmMarketResponse = {
  id: 'Test Market Id',
  code: 'Test Market Code',
  name: 'Test Market Name',
};
